import loadable from '../../utilities/loadable'

export const SendInvites = loadable(() => import('./SendInvites'))
